import createIcon from '../../createIcon';

/**
 * @component @name AppShortcut
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUgMThINVY2SDE1VjdIMTdWM0MxNyAxLjkgMTYuMSAxIDE1IDFINUMzLjkgMSAzIDEuOSAzIDNWMjFDMyAyMi4xIDMuOSAyMyA1IDIzSDE1QzE2LjEgMjMgMTcgMjIuMSAxNyAyMVYxN0gxNVYxOFoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOC4zOCA5LjYyTDE5IDExTDE5LjYyIDkuNjJMMjEgOUwxOS42MiA4LjM4TDE5IDdMMTguMzggOC4zOEwxNyA5TDE4LjM4IDkuNjJaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTQgOEwxMi43NSAxMC43NUwxMCAxMkwxMi43NSAxMy4yNUwxNCAxNkwxNS4yNSAxMy4yNUwxOCAxMkwxNS4yNSAxMC43NUwxNCA4WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5IDEzTDE4LjM4IDE0LjM4TDE3IDE1TDE4LjM4IDE1LjYyTDE5IDE3TDE5LjYyIDE1LjYyTDIxIDE1TDE5LjYyIDE0LjM4TDE5IDEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AppShortcut = createIcon('AppShortcut', [
  [
    'path',
    {
      d: 'M15 18H5V6H15V7H17V3C17 1.9 16.1 1 15 1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H15C16.1 23 17 22.1 17 21V17H15V18Z',
      key: '1k9tsd',
    },
  ],
  [
    'path',
    {
      d: 'M18.38 9.62L19 11L19.62 9.62L21 9L19.62 8.38L19 7L18.38 8.38L17 9L18.38 9.62Z',
      key: 'tjikce',
    },
  ],
  [
    'path',
    {
      d: 'M14 8L12.75 10.75L10 12L12.75 13.25L14 16L15.25 13.25L18 12L15.25 10.75L14 8Z',
      key: 'q8buih',
    },
  ],
  [
    'path',
    {
      d: 'M19 13L18.38 14.38L17 15L18.38 15.62L19 17L19.62 15.62L21 15L19.62 14.38L19 13Z',
      key: '1kxo32',
    },
  ],
]);

export default AppShortcut;
